<script>
  import { getContext, createEventDispatcher } from 'svelte';
  import { onMount } from 'svelte';
  import { debounce } from 'lodash';

  export let type = 'text';
  export let label;
  export let name;
  export let initialValue;
  export let value;
  export let cssClass = "";
  
  const dispatch = createEventDispatcher();
  const debounceTimeMs = 700;

  onMount(() => {
    value = initialValue || '';
  });

  const onChange = debounce((e) => {
    dispatch('onChange', e);
  }, debounceTimeMs);

</script>

<div class="mt-1 sm:mt-0 sm:col-span-2 w-max-content">
  <input
    {value}
    {type}
    {name}
    on:input={onChange}
    on:keydown={(e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }}
    placeholder={label}
    class={`w-full block shadow-sm focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm border-gray-300 rounded-md ${cssClass}`}
  />
</div>
